<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Instruction Subcontract Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryinstructionsubcontract"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="deliveryInstructionSubcontractInput">


        <b-card header="Delivery Instruction Subcontract" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="DI Number" :model="model.diNumber" />
						<app-input-combobox-autocomplete :options="deliveryOrders" optionsLabel="doNumber" optionsKey="id" label-cols-lg="12" label="Delivery Order" id="fieldset-delivery-order" size="sm" :model.sync="model.deliveryOrderId"   :selected="model.deliveryOrder != null ? model.deliveryOrder.doNumber : ''" @input="getDeliveryOrders" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryOrder" />
						<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO No Customer" label-for="input-po-no-customer" size="sm" :model.sync="model.poNoCustomer"  @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker  id="fieldset-di-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.diDeliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-datepicker  id="fieldset-di-create-date" label-cols-lg="12"  label="Create Date" size="sm" :model.sync="model.diCreateDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-combobox-autocomplete :options="deliveryInstructionStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Delivery Instruction Status" id="fieldset-di-status" size="sm" :model.sync="model.diStatusId"   :selected="model.diStatus != null ? model.diStatus.name : ''" @input="getDeliveryInstructionStatuss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDiStatus" />
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Destination Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-di-customer" size="sm" :model.sync="model.diCustomerId"   :selected="model.diCustomer != null ? model.diCustomer.code : ''" @input="getCustomers" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDiCustomer" />
						<app-input-combobox-autocomplete :options="partDestinations" optionsLabel="destination" optionsKey="id" label-cols-lg="12" label="Part Destination" id="fieldset-part-destination" size="sm" :model.sync="model.partDestinationId"   :selected="model.partDestination != null ? model.partDestination.destination : ''" @input="getPartDestinations" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartDestination" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Destination" id="fieldset-destination" size="sm" :model.sync="model.destinationId"   :selected="model.destination != null ? model.destination.code : ''" @input="getCustomers" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDestination" />
						<app-label label-cols-lg="12" size="sm" label="Office Address Destination" :model="(model.destination != null) ? model.destination.officeAddress : null"  />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "DeliveryInstructionSubcontractDetails"
			:bordered="true" :items="deliveryInstructionSubcontractDetails" 
			:fields="fieldsDeliveryInstructionSubcontractDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByDeliveryInstructionSubcontractDetail" 
			:sort-desc.sync="sortDescDeliveryInstructionSubcontractDetail" small responsive	
			@editButtonMethod="editRowDataDeliveryInstructionSubcontractDetail"	
			@deleteButtonMethod="deleteRowDataDeliveryInstructionSubcontractDetail"	
			@showPopupAddMethod="addDataDeliveryInstructionSubcontractDetail()"	
			@showPopupUploadMethod="showPopupUploadDeliveryInstructionSubcontractDetail()"
			@downloadMethod="downloadDeliveryInstructionSubcontractDetail()"
			@addFromClipboardMethod="addFromClipboardDeliveryInstructionSubcontractDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardDeliveryInstructionSubcontractDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadDeliveryInstructionSubcontractDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowDeliveryInstructionSubcontractDetailFilter = !isShowDeliveryInstructionSubcontractDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowDeliveryInstructionSubcontractDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-delivery-instruction-subcontract-details-part-table" append-to-body label="partNumber" :options="parts" :value="filterDeliveryInstructionSubcontractDetail.partId" :reduce="item => item.id" v-model="filterDeliveryInstructionSubcontractDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Delivery">
					<b-form-input id="input-delivery-instruction-subcontract-details-qty-delivery-table" v-model="filterDeliveryInstructionSubcontractDetail.qtyDelivery" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( deliveryInstructionSubcontractDetailPageSize * (currentDeliveryInstructionSubcontractDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-delivery-instruction-subcontract-details-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputDeliveryInstructionSubcontractDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(qtyDelivery)="row">
				<app-input-textbox :id="'input-delivery-instruction-subcontract-details-qty-delivery-' + row.index" label-cols-lg="12" label="Qty Delivery" size="sm" :model.sync="row.item.qtyDelivery"   @change="saveInputDeliveryInstructionSubcontractDetail(row.item)"   :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<DeliveryInstructionSubcontractDetailInput 
					:model="modelDeliveryInstructionSubcontractDetail"
					:openPopup="isShowPopupDeliveryInstructionSubcontractDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataDeliveryInstructionSubcontractDetail"/>
			</template>
			<template v-slot:upload-detail>
					<DeliveryInstructionSubcontractDetailUpload
					:openPopup="isShowPopupUploadDeliveryInstructionSubcontractDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataDeliveryInstructionSubcontractDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentDeliveryInstructionSubcontractDetailPage"
				:total-rows="totalDeliveryInstructionSubcontractDetailRow"
				:per-page="deliveryInstructionSubcontractDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstructionSubcontract from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontract';
import DeliveryInstructionSubcontractList from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractList';
import DeliveryInstructionSubcontractFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DeliveryInstructionStatus from '@/models/DeliveryInstructionStatus/DeliveryInstructionStatus';
import DeliveryInstructionStatusFilter from '@/filters/DeliveryInstructionStatus/DeliveryInstructionStatusFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import PartDestination from '@/models/PartDestination/PartDestination';
import PartDestinationFilter from '@/filters/PartDestination/PartDestinationFilter';
import DeliveryInstructionSubcontractDetail from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetail';
import DeliveryInstructionSubcontractDetailFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import DeliveryOrderDetail from '@/models/DeliveryOrder/DeliveryOrderDetail';
import DeliveryOrderDetailFilter from '@/filters/DeliveryOrder/DeliveryOrderDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import DeliveryInstructionSubcontractDetailInput from '@/views/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetailInput';
import DeliveryInstructionSubcontractDetailUpload from '@/views/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		DeliveryInstructionSubcontractDetailInput,DeliveryInstructionSubcontractDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsDeliveryInstructionSubcontractDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"qtyDelivery": { "class" : "th-qty-delivery last-child", "label" : "Qty Delivery", key: 'qtyDelivery', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelDeliveryInstructionSubcontractDetail : {},
			isShowPopupDeliveryInstructionSubcontractDetail : false,
			isShowPopupUploadDeliveryInstructionSubcontractDetail : false,
			filterDeliveryInstructionSubcontract : null,
			currentDeliveryInstructionSubcontractPage : 1,
			deliveryInstructionSubcontractPageSize: 10,
			sortByDeliveryInstructionSubcontract: '',
			sortDescDeliveryInstructionSubcontract: '',
			filterDeliveryInstructionSubcontractDetail : null,
			currentDeliveryInstructionSubcontractDetailPage : 1,
			deliveryInstructionSubcontractDetailPageSize: 10,
			sortByDeliveryInstructionSubcontractDetail: '',
			sortDescDeliveryInstructionSubcontractDetail: '',
			sortingByDeliveryInstructionSubcontractDetail: [],
			deliveryInstructionSubcontractDetails : [],
			deliveryInstructionSubcontractDetailId : '',
			totalDeliveryInstructionSubcontractDetailRow : 0,
			isShowDeliveryInstructionSubcontractDetailFilter: false,
			isDownloadDeliveryInstructionSubcontractDetail: false,
			parts: [],
			deliveryOrders: [],
			deliveryOrders: [],
			isDeliveryOrderComboLoading: false,
			deliveryInstructionStatuss: [],
			diStatuss: [],
			isDiStatusComboLoading: false,
			customers: [],
			diCustomers: [],
			isDiCustomerComboLoading: false,
			partDestinations: [],
			partDestinations: [],
			isPartDestinationComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryOrderComboLoading: false,
			isDeliveryInstructionStatusComboLoading: false,
			isCustomerComboLoading: false,
			isPartDestinationComboLoading: false,
			isDeliveryInstructionSubcontractComboLoading: false,
			isPartComboLoading: false,
			isDeliveryOrderDetailComboLoading: false,
		}
	},
	methods : {
		getDeliveryInstructionSubcontract : async function(id) {
			this.isBusy = true;
			DeliveryInstructionSubcontract.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.destinationId != null) {
					promises.push(
						this.getCustomer(this.model.destinationId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryInstructionSubcontract = true;
			this.filterDeliveryInstructionSubcontract.id = this.modelId;
			DeliveryInstructionSubcontract.downloadDataDetail(this, this.filterDeliveryInstructionSubcontract).then(result => {
				this.isDownloadDeliveryInstructionSubcontract = false;
			}).catch(error => { this.isDownloadDeliveryInstructionSubcontract = false; })
		},
		getDeliveryInstructionSubcontractDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterDeliveryInstructionSubcontractDetail);
			if (this.modelId == null) return;
			filter.deliveryInstructionSubcontractId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByDeliveryInstructionSubcontractDetail != null) {
				this.sortingByDeliveryInstructionSubcontractDetail[this.sortByDeliveryInstructionSubcontractDetail] = this.sortDescDeliveryInstructionSubcontractDetail;
			}
			let currentPage = (this.currentDeliveryInstructionSubcontractDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalDeliveryInstructionSubcontractDetailRow + 1;
				let page = Math.ceil(totalData/this.deliveryInstructionSubcontractDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.deliveryInstructionSubcontractDetailPageSize = 0;
			// disable paging end
			DeliveryInstructionSubcontractDetail.getList(this, filter, this.sortingByDeliveryInstructionSubcontractDetail, currentPage , this.deliveryInstructionSubcontractDetailPageSize).then(result => {
				this.currentDeliveryInstructionSubcontractDetailPage = currentPage + 1;
				this.deliveryInstructionSubcontractDetails = result.data;
				this.totalDeliveryInstructionSubcontractDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getDeliveryInstructionSubcontracts : async function(input) {
			let filter = new DeliveryInstructionSubcontractFilter();
			if (input != undefined) {
				filter.DiNumber = input;
			}
			this.isDeliveryInstructionSubcontractComboLoading = true;
			DeliveryInstructionSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontracts = result.data
				}
				this.isDeliveryInstructionSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionSubcontracts : async function(input) {
			let filter = new DeliveryInstructionSubcontractFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			this.isDeliveryInstructionSubcontractComboLoading = true;
			DeliveryInstructionSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontracts = result.data
				}
				this.isDeliveryInstructionSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryOrderDetails : async function(input) {
			let filter = new DeliveryOrderDetailFilter();
			if (input != undefined) {
				filter.poNumber = input;
			}
			this.isDeliveryOrderDetailComboLoading = true;
			DeliveryOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrderDetails = result.data
				}
				this.isDeliveryOrderDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionStatuss : async function(input) {
			let filter = new DeliveryInstructionStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDeliveryInstructionStatusComboLoading = true;
			DeliveryInstructionStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionStatuss = result.data
				}
				this.isDeliveryInstructionStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryOrders : async function(input) {
			let filter = new DeliveryOrderFilter();
			if (input != undefined) {
				filter.doNumber = input;
			}
			DeliveryOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrders = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryOrder(item) {
			if(item == undefined || item == null) {
				this.model.deliveryOrderId = null;
				this.model.deliveryOrder = null;
			} else {
				this.model.deliveryOrderId = item.id;
				this.model.deliveryOrder = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDiStatus(item) {
			if(item == undefined || item == null) {
				this.model.diStatusId = null;
				this.model.diStatus = null;
			} else {
				this.model.diStatusId = item.id;
				this.model.diStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDiCustomer(item) {
			if(item == undefined || item == null) {
				this.model.diCustomerId = null;
				this.model.diCustomer = null;
			} else {
				this.model.diCustomerId = item.id;
				this.model.diCustomer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPartDestinations : async function(input) {
			let filter = new PartDestinationFilter();
			if (input != undefined) {
				filter.destination = input;
			}
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinations = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartDestination(item) {
			if(item == undefined || item == null) {
				this.model.partDestinationId = null;
				this.model.partDestination = null;
			} else {
				this.model.partDestinationId = item.id;
				this.model.partDestination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDestination(item) {
			if(item == undefined || item == null) {
				this.model.destinationId = null;
				this.model.destination = null;
			} else {
				this.model.destinationId = item.id;
				this.model.destination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomer : async function(id) {
			Customer.getData(this, id).then(result => {
				this.model.destination = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryInstructionSubcontractInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionSubcontract.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryinstructionsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					DeliveryInstructionSubcontract.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryinstructionsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionSubcontract.updateData(this, model, id)
					.catch((error) => {
						this.getDeliveryInstructionSubcontract(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryInstructionSubcontracts();
		},
		addRowDataDeliveryInstructionSubcontractDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.deliveryInstructionSubcontractId =  this.modelId;
					DeliveryInstructionSubcontractDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getDeliveryInstructionSubcontractDetails(true);
						this.isShowPopupDeliveryInstructionSubcontractDetail = false;
					})
				} else {
					model.deliveryInstructionSubcontractId =  this.modelId;
					DeliveryInstructionSubcontractDetail.createDataDetail(this, model)
					.then(result => {
						this.getDeliveryInstructionSubcontractDetails(true);
						this.isShowPopupDeliveryInstructionSubcontractDetail = false;
					})
				}
			}
		},
		async editRowDataDeliveryInstructionSubcontractDetail(id) {
			this.deliveryInstructionSubcontractDetailId = id;
			this.isShowPopupDeliveryInstructionSubcontractDetail = true; 
		},
		async deleteRowDataDeliveryInstructionSubcontractDetail(id) {
			DeliveryInstructionSubcontractDetail.deleteData(this, id).then(result => { this.getDeliveryInstructionSubcontractDetails(); });
		},
		async resetDataDeliveryInstructionSubcontractDetail() {
			this.deliveryInstructionSubcontractDetailId = "";
			this.isShowPopupDeliveryInstructionSubcontractDetail = true;
		},
		async addDataDeliveryInstructionSubcontractDetail() {
			DeliveryInstructionSubcontractDetail.createData(this, { deliveryInstructionSubcontractId: this.modelId })
			.then(result => {
				this.getDeliveryInstructionSubcontractDetails(true);
			})
		},
		async addFromClipboardDeliveryInstructionSubcontractDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryInstructionSubcontractId: this.modelId });
				});
				DeliveryInstructionSubcontractDetail.addFromClipboard(this, parts).then(result => { this.getDeliveryInstructionSubcontractDetails() });
			});
		},
		async replaceFromClipboardDeliveryInstructionSubcontractDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryInstructionSubcontractId: this.modelId });
				});
				DeliveryInstructionSubcontractDetail.replaceFromClipboard(this, parts).then(result => { this.getDeliveryInstructionSubcontractDetails() });
			});   
		},
		showPopupUploadDeliveryInstructionSubcontractDetail() {
			if(this.deliveryInstructionSubcontractDetails != null && this.deliveryInstructionSubcontractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap DeliveryInstructionSubcontractDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadDeliveryInstructionSubcontractDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadDeliveryInstructionSubcontractDetail = true;
			}
		},
		uploadDataDeliveryInstructionSubcontractDetail(modalEvent, newDatas) {
			this.isShowPopupUploadDeliveryInstructionSubcontractDetail = false; 
		},
		downloadDeliveryInstructionSubcontractDetail(modalEvent) {
			this.isDownloadDeliveryInstructionSubcontractDetail = true;
			this.filterDeliveryInstructionSubcontractDetail.deliveryInstructionSubcontractId = this.modelId;
			DeliveryInstructionSubcontractDetail.downloadDataDetail(this, this.filterDeliveryInstructionSubcontractDetail).then(result => {
				this.isDownloadDeliveryInstructionSubcontractDetail = false;
			}).catch(error => { this.isDownloadDeliveryInstructionSubcontractDetail = false; })
		},
		saveInputDeliveryInstructionSubcontractDetail(item) {
			if (this.deliveryInstructionSubcontracts != null && this.deliveryInstructionSubcontracts != undefined  && this.deliveryInstructionSubcontracts.length > 0) {
				item.deliveryInstructionSubcontract = this.deliveryInstructionSubcontracts.find(q => q.id == item.deliveryInstructionSubcontractId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.deliveryOrderDetails != null && this.deliveryOrderDetails != undefined  && this.deliveryOrderDetails.length > 0) {
				item.deliveryOrderDetail = this.deliveryOrderDetails.find(q => q.id == item.deliveryOrderDetailId);
			}
			if (this.deliveryInstructionStatuss != null && this.deliveryInstructionStatuss != undefined  && this.deliveryInstructionStatuss.length > 0) {
				item.deliveryInstructionStatus = this.deliveryInstructionStatuss.find(q => q.id == item.deliveryInstructionStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionSubcontractDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadDeliveryInstructionSubcontractDetail = false; 
			this.isShowPopupDeliveryInstructionSubcontractDetail = false; 
			if (modalType == 'DeliveryInstructionSubcontractDetail') {
				this.getDeliveryInstructionSubcontractDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowDeliveryInstructionSubcontractDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterDeliveryInstructionSubcontract = new DeliveryInstructionSubcontractFilter();
		this.filterDeliveryInstructionSubcontractDetail = new DeliveryInstructionSubcontractDetailFilter();
		//this.getDeliveryInstructionSubcontracts();
		//this.getParts();
		//this.getDeliveryOrderDetails();
		//this.getDeliveryInstructionStatuss();
		//this.getDeliveryOrders();
		//this.getCustomers();
		//this.getPartDestinations();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryInstructionSubcontract(id);
			} else {
				this.modelId = id;
				this.getDeliveryInstructionSubcontract(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByDeliveryInstructionSubcontractDetail : {
			handler: function() {
				this.getDeliveryInstructionSubcontractDetails();
			}
		},
		sortDescDeliveryInstructionSubcontractDetail: {
			handler: function() {
				this.getDeliveryInstructionSubcontractDetails();
			}
		},
		currentDeliveryInstructionSubcontractDetailPage: {
			handler: function() {
				this.getDeliveryInstructionSubcontractDetails();
			}
		},
		deliveryInstructionSubcontractDetailPageSize : {
			handler: function() {
				this.getDeliveryInstructionSubcontractDetails();
			}
		},
		filterDeliveryInstructionSubcontractDetail: {
			handler: function() {
				this.getDeliveryInstructionSubcontractDetails();
			},
			deep: true,
		},
	},
}
</script>
